var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-td-button-select"},[_c('MdtButtonSelect',{attrs:{"items":_vm.proposalItems.length ? _vm.proposalItems : _vm.items,"test-key":_vm.testKey,"disabled":_vm.disabled,"tooltip":_vm.tooltips[_vm.tableRow._progress_state],"relative":true,"size":'size-32'},on:{"buttonSelect":_vm.openModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }